export default __webpack_public_path__ + "static/media/ShjMunUniPortal-LogoBGVer.bf3a8e0c.svg";